import { Paper, TextField, Typography } from "@mui/material";
import { useState } from "react";

interface TermsAndConditionsSectionProps {
  onChange?: (value: string) => void;
  initialValue?: string;
}

export default function TermsAndConditionsSection({
  onChange,
  initialValue = "",
}: TermsAndConditionsSectionProps) {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onChange?.(e.target.value);
  };

  return (
    <Paper sx={{ borderRadius: "14px", p: 2.5, boxShadow: 0, mb: 2 }}>
      <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "#1e293b", mb: 1.5 }}>
        Terms & Conditions
      </Typography>
      <TextField
        multiline
        minRows={4}
        fullWidth
        value={value}
        onChange={handleChange}
        placeholder="Enter terms and conditions..."
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            bgcolor: "#f8fafc",
            fontSize: "13px",
            color: "#475569",
            lineHeight: 1.8,
            "& fieldset": { border: "1px solid #e2e8f0" },
            "&:hover fieldset": { borderColor: "#c59a70" },
            "&.Mui-focused fieldset": { borderColor: "#724e41", borderWidth: 1 },
          },
        }}
      />
    </Paper>
  );
}